export const POST_LIKED_VIDEO_REQUEST = "POST_LIKED_VIDEO_REQUEST";
export const POST_LIKED_VIDEO_SUCCESS = "POST_LIKED_VIDEO_SUCCESS";
export const POST_LIKED_VIDEO_ERROR = "POST_LIKED_VIDEO_ERROR";

export const GET_LIKED_VIDEO_REQUEST = "GET_LIKED_VIDEO_REQUEST";
export const GET_LIKED_VIDEO_SUCCESS = "GET_LIKED_VIDEO_SUCCESS";
export const GET_LIKED_VIDEO_ERROR = "GET_LIKED_VIDEO_ERROR";

export const POST_DISLIKED_VIDEO_REQUEST = "POST_DISLIKED_VIDEO_REQUEST";
export const POST_DISLIKED_VIDEO_SUCCESS = "POST_DISLIKED_VIDEO_SUCCESS";
export const POST_DISLIKED_VIDEO_ERROR = "POST_DISLIKED_VIDEO_ERROR";